/* eslint-disable no-unreachable */
// TODO: remove code above and fix issues in case changing this file
'use strict';

(function() {
	angular
		.module('onboarding.common')
		.directive('cobDatePicker',
			function() {

				return {
					restrict: 'E',
					scope: {
						fromDate: '=',
						toDate: '=',
						placeholder: '='
					},
					templateUrl: '/app/common/directives/cobDatePicker.html',
					link: function(scope) {

						activate();

						function activate() {

							if (!scope.fromDate) {
								scope.fromDate = '';
							}
							if (!scope.toDate) {
								scope.toDate = '';
							}
							if (!scope.dateFormat) {
								scope.dateFormat = 'mm/dd/y';
							}

							//todo make this stuff work for range

							//scope.placeholder = attrs.placeholder;

							//element.find('input').datepicker({
							//    dateFormat: scope.dateFormat,
							//    maxDate: '0'
							//});

							//element.find('input').datepicker({
							//    dateFormat: scope.dateFormat,
							//    maxDate: '0',
							//    onSelect: onSelect,
							//    beforeShowDay: beforeShowDay
							//});
						}

						//todo make this stuff work for range
						function beforeShowDay(date) {
							var date1 = $.datepicker.parseDate(scope.dateFormat, scope.fromDate);
							var date2 = $.datepicker.parseDate(scope.dateFormat, scope.toDate);
							var selectedClass = 'dp-highligh';
							var notSelectedClass = '';


							if (date2 && date >= date1 && date <= date2) {
								return [true, selectedClass];
							} else {
								return [true, notSelectedClass];
							}

							return [
								true, date1 &&
								((date.getTime() == date1.getTime()) || (date2 && date >= date1 && date <= date2))
									? 'dp-highligh'
									: ''
							];
						}

						//todo make this stuff work for range
						function onSelect(dateText, inst) {

							var date1 = $.datepicker.parseDate(scope.dateFormat, scope.fromDate);
							var date2 = $.datepicker.parseDate(scope.dateFormat, scope.toDate);
							if (!date1 || date2) {
								scope.fromDate = dateText;
								scope.toDate = '';
								$(this).datepicker();
							} else {
								if (new Date(dateText) > new Date(scope.fromDate)) {
									scope.toDate = dateText;
								} else {
									scope.toDate = scope.fromDate;
									scope.fromDate = dateText;
								}
								$(this).datepicker();
							}
							scope.$apply();
						}
					}
				};
			});
})();

/* jQuery UI Datepicker plugin wrapper */
(function() {
	angular
		.module('onboarding.common')
		.directive('jqDatePicker',
			function() {
				return {
					restrict: 'A',
					require: 'ngModel',
					link: link
				};

				function link(scope, element, attrs, ngModelCtrl) {
					activate();

					function activate() {
						element.datepicker({
							dateFormat: 'mm/dd/y',
							onSelect: onSelect
						});
					}

					function onSelect(date) {
						scope.$apply(function() {
							ngModelCtrl.$setViewValue(date);
						});
					}
				}
			});
})();
